export default __webpack_public_path__ + "static/media/main_saying03_en.16c02256.png";